import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import type { Invoice } from '~/api/invoices/types';

import { Icon } from '~/components';
import { isNotPaidYet } from '~/features/documents';
import { statusColorThemes } from '~/styles/themes.css';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { invoiceDocumentDateCellStyle } from './invoiceCell.css';

type Props = {
  invoice: Invoice;
};

export const InvoiceDocumentDateCell = ({ invoice }: Props) => {
  const { t } = useTranslation(['invoices']);

  if (invoice.status === 'Draft') return '–';

  const daysUntilExpired = dayjs(invoice.dueDate).startOf('day').diff(dayjs().startOf('day'), 'day');

  return (
    <div className={desktopTruncateStyle}>
      <span>{dayjs(invoice.documentDate).format('DD/MM/YYYY')}</span>

      {isNotPaidYet(invoice) && (
        <div className={clsx(desktopTruncateStyle, daysUntilExpired < 0 && statusColorThemes.danger, invoiceDocumentDateCellStyle)}>
          <Icon inline name={daysUntilExpired > 0 ? 'HourglassTop' : 'HourglassBottom'} size={16} />

          <span>
            {daysUntilExpired > 0
              ? `${daysUntilExpired} ${t('invoices:overview.columns.days')}`
              : dayjs(invoice.dueDate).format('DD/MM/YYYY')}
          </span>
        </div>
      )}
    </div>
  );
};
